import { Offer } from '@appTypes/essential-ui/Offer';
import { useFilteredOffers } from './UseFilteredOffers';

export const useCurrentOffer = (id: string): UseCurrentOfferReturnType => {
  let previousDealId = '';
  let nextDealId = '';
  let previousDealerId = '';
  let nextDealerId = '';
  const { offers } = useFilteredOffers();
  const currentOffer = offers.find((offer) => offer.id === id);

  if (currentOffer) {
    const indexOfCurrentElement = offers.indexOf(currentOffer);
    if (indexOfCurrentElement < offers.length - 1) {
      nextDealId = offers[indexOfCurrentElement + 1].id;
      nextDealerId = offers[indexOfCurrentElement + 1].dealerId;
    }
    if (indexOfCurrentElement > 0) {
      previousDealId = offers[indexOfCurrentElement - 1].id;
      previousDealerId = offers[indexOfCurrentElement - 1].dealerId;
    }
  }
  return {
    currentOffer,
    previousDealId,
    nextDealId,
    previousDealerId,
    nextDealerId,
  };
};

export const useCurrentOfferForDashboard = (id: string): UseCurrentOfferReturnType => {
  let previousDealId = '';
  let nextDealId = '';
  let noOfferMatching = false;
  let previousDealerId = '';
  let nextDealerId = '';

  const { offers, loading } = useFilteredOffers();

  const currentOffer = offers.find((offer) => offer.id === id);

  if (!currentOffer && !loading && offers.length > 0) {
    noOfferMatching = true;
  } else {
    noOfferMatching = false;
  }
  if (currentOffer) {
    const indexOfCurrentElement = offers.indexOf(currentOffer);
    if (indexOfCurrentElement < offers.length - 1) {
      nextDealId = offers[indexOfCurrentElement + 1].id;
      nextDealerId = offers[indexOfCurrentElement + 1].dealerId;
    }
    if (indexOfCurrentElement > 0) {
      previousDealId = offers[indexOfCurrentElement - 1].id;
      previousDealerId = offers[indexOfCurrentElement - 1].dealerId;
    }
  }
  return {
    currentOffer,
    previousDealId,
    nextDealId,
    noOfferMatching,
    previousDealerId,
    nextDealerId,
  };
};

type UseCurrentOfferReturnType = {
  currentOffer: Offer | undefined;
  previousDealId: string;
  nextDealId: string;
  noOfferMatching?: boolean;
  previousDealerId: string;
  nextDealerId: string;
};
